import React, { useState, useEffect } from 'react';
import { Modal, View, Text, TouchableOpacity, StyleSheet, Platform, DeviceEventEmitter } from 'react-native';
import { useTranslation } from 'react-i18next';
import { priceFormatter } from '../helpers/numbers';
import Icon from 'react-native-vector-icons/Feather';

const TeyaPaymentDialog = () => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [amount, setAmount] = useState(0);
    const [onComplete, setOnComplete] = useState(null);
    const [onCancel, setOnCancel] = useState(null);

    useEffect(() => {
        console.log("TeyaPaymentDialog component mounted");
        // Set up event listener for Teya payment pending
        const handleTeyaPaymentPending = (event) => {
            console.log("teyaPaymentPending event received:", event);
            const data = Platform.OS === 'web' ? event.detail : event;
            console.log("Setting dialog data:", data);
            setVisible(data.visible);
            setAmount(data.amount);
            setOnComplete(data.onComplete);
            setOnCancel(data.onCancel);
        };

        // Add event listener
        if (Platform.OS === 'web') {
            console.log("Adding web event listener for teyaPaymentPending");
            window.addEventListener('teyaPaymentPending', handleTeyaPaymentPending);
        } else {
            console.log("Adding DeviceEventEmitter listener for teyaPaymentPending");
            // For React Native, use DeviceEventEmitter
            const subscription = DeviceEventEmitter.addListener('teyaPaymentPending', handleTeyaPaymentPending);
            return () => {
                console.log("Removing DeviceEventEmitter listener for teyaPaymentPending");
                subscription.remove();
            };
        }

        // Clean up event listener
        return () => {
            if (Platform.OS === 'web') {
                console.log("Removing web event listener for teyaPaymentPending");
                window.removeEventListener('teyaPaymentPending', handleTeyaPaymentPending);
            }
        };
    }, []);

    const handleComplete = () => {
        if (onComplete) {
            onComplete();
        }
        setVisible(false);
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
        setVisible(false);
    };

    if (!visible) {
        return null;
    }

    return (
        <Modal
            visible={visible}
            transparent={true}
            animationType="fade"
            onRequestClose={handleCancel}
        >
            <View style={styles.modalContainer}>
                <View style={styles.modalContent}>
                    <View style={styles.iconContainer}>
                        <Icon name="credit-card" size={50} color="#F76E24" />
                    </View>

                    <Text style={styles.modalTitle}>{t('credit_card_payment_pending')}</Text>

                    <Text style={styles.modalText}>
                        {t('please_complete_payment_on_terminal', { amount: priceFormatter(amount) })}
                    </Text>

                    <View style={styles.buttonContainer}>
                        <TouchableOpacity style={styles.cancelButton} onPress={handleCancel}>
                            <Text style={styles.cancelButtonText}>{t('cancel')}</Text>
                        </TouchableOpacity>

                        <TouchableOpacity style={styles.completeButton} onPress={handleComplete}>
                            <Text style={styles.completeButtonText}>{t('payment_completed')}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    modalContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    modalContent: {
        backgroundColor: 'white',
        borderRadius: 10,
        padding: 20,
        width: '80%',
        maxWidth: 400,
        alignItems: 'center',
    },
    iconContainer: {
        marginBottom: 20,
    },
    modalTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 10,
        textAlign: 'center',
    },
    modalText: {
        fontSize: 16,
        marginBottom: 20,
        textAlign: 'center',
    },
    buttonContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    cancelButton: {
        backgroundColor: '#ccc',
        padding: 10,
        borderRadius: 5,
        flex: 1,
        marginRight: 10,
        alignItems: 'center',
    },
    cancelButtonText: {
        color: '#333',
        fontWeight: 'bold',
    },
    completeButton: {
        backgroundColor: '#F76E24',
        padding: 10,
        borderRadius: 5,
        flex: 1,
        marginLeft: 10,
        alignItems: 'center',
    },
    completeButtonText: {
        color: 'white',
        fontWeight: 'bold',
    },
});

export default TeyaPaymentDialog;
